<panel>
	<menu always-visible>
		@if (!domain.productPlanId) {<menuitem *requiredCredential="domainCleanUpCredential" (click)="changeDomainOwner()" icon="suitcase">{{ 'company.domains.change-domain-owner' | translate }}</menuitem>}
		<menuitem [disabled]="!isResetable" (click)="resetRegistrarAction()" icon="broom-wide">{{ 'company.domains.reset-domain' | translate }}</menuitem>
		@if (isValidDomainDk) {<menuitem (click)="changeDomainEmail()" icon="envelope" icon-family="solid">{{ 'company.domains.change-domain-email' | translate }}</menuitem>} 
		<menuitem [disabled]="!!domain.deleted || (domain.status && domain.status.length > 0) || !!domain.productPlanId" (click)="removeDomain()" icon="trash">{{ 'company.domains.remove' | translate }}</menuitem>
	</menu>
	<h1>{{ domain.name }}</h1>
	@if (domain.status && domain.status.length > 0) {
		<h3>
			{{ 'company.domains.status-header' | translate }}
			@if (lastStatusCheckTimestamp) { <em>({{ 'company.domains-status-updated-on' | translate: { time: (lastStatusCheckTimestamp | customDate: 'time') } }})</em> }
		</h3>

		<list-view [selectable]="false" emptyLabel="">
			@for (status of domain.status; track status) {
			<list-item [attr.info]="!isWarningStatus(status) ? '' : null" [attr.warning]="isWarningStatus(status) ? '' : null" [statusIcon]="isWarningStatus(status) ? 'exclamation-triangle' : 'clock'">
				@if (isWarningStatus(status)) { {{ ('domain.status.' + status) | translate }} }
				@else { {{ ('company.domains.order-in-progress.' + status) | translate: { 'domain': domain.name, 'taskCreatedTime': (awaitingTaskAction ? (awaitingTaskAction.created | customDate: 'shortDate') : '') } }} }
			</list-item>
			}
		</list-view>			

		@if (domain.status.indexOf('awaiting-authid') >= 0) {
			<form>
				<section four-columns>
					<custom-input [(value)]="authId" [label]="'company.domains.auth-id' | translate" />
					<button #submitAuthIdButton confirm [active]="!!authId" (click)="submitAuthId()"><icon type="key" /> {{ 'company.domains.submit-auth-id' | translate }}</button>
				</section>
			</form>
		}
		@if (domain.status.indexOf('is-registrar-managed') >= 0 && attachToNewPlanPermission) {
			<section>
				<button (click)="attachToNewPlan()" [loader]="false" [active]="!domain.productPlanId"><icon type="plus" />{{ 'company.domains.create-product-plan' | translate }}</button>
			</section>
		}
	}
	@if (!domain.deleted) {
	
		@if (domain.status?.length == 0) {
			<h3>{{ 'company.domains.domain-information' | translate }}</h3>
			<domain-dns-details [dnsResult]="domain" />
			@if (isRegistrarManaged()) {
				<section>
					<text-group>
						<div>{{ 'company.domains.expire-date' | translate }}</div>
						<div>
							@if (domain.renewalInfo) { {{ domain.renewalInfo.expireDate | customDate: 'shortDate' }} }
							@else { <skeleton /> }
						</div>

						<div>{{ 'company.domains.renewal-period' | translate }}</div>
						<div>
							@if (domain.renewalInfo) { {{ domain.renewalInfo.renewalPeriodMonths | paymentInterval }} }
							@else { <skeleton /> }
						</div>

						<div>{{ 'company.domains.auth-id' | translate }}</div>
						<div>
							@if (domain.authId) { {{ domain.authId }} <tooltip [text]="'company.domains.copy-auth-id' | translate" [showDelay]="200"><icon small type="copy" (click)="copyAuthId()" /></tooltip> }
							@else { <button small #getAuthIdButton [active]="canGetAuthId" (click)="getAuthId()">{{ 'company.domains.get-auth-id' | translate }}</button> }
						</div>
					</text-group>
				</section>
			}
		}
		@if (!domainHasProcessableStatus) {
			<section>
				<button *requiredCredential="domainTransferCredential" (click)="transferToRegistrar()" [loader]="false" [active]="!!dnsRecords && !isOurNameserver() && !domain.productPlanId"><icon type="exchange" />{{ 'company.domains.transfer-registrant-owned' | translate }}</button>
			</section>
		}

		<h3>{{ 'company.domains.dns-header' | translate }}</h3>
		<list-view [selectable]="false" emptyLabel="">
			@if (!isOurNameserver()) { <list-item warning statusIcon="exclamation-triangle">{{ 'company.domains.not-on-hosted-nameserver' | translate }}</list-item> }
			@if (dnsResponseStatus) { <list-item warning statusIcon="exclamation-triangle">{{ 'company.domains.dns-status.' + dnsResponseStatusEnum[dnsResponseStatus] | translate }}</list-item> }
		</list-view>
		@if (dnsRecords) {
			<list-view scrollable [selectable]="false">
				<header>{{ 'dns-records.name' | translate }}</header>
				<header>{{ 'dns-records.type' | translate }}</header>
				<header>{{ 'dns-records.ttl' | translate }}</header>
				<header>{{ 'dns-records.data' | translate }}</header>
				<row *listData="let record from dnsRecords">
					<column>{{ record.name }}</column>
					<column>{{ recordType[record.type] }}</column>
					<column>{{ record.ttl }}</column>
					<column>{{ record.data }}</column>
				</row>
			</list-view>
		}
		@else if (dnsResponseStatus === undefined) {
			<skeletons [defaultSkeletons]="4" />
		}
		@if (dnsRecords || dnsResponseStatus === dnsResponseStatusEnum.PendingChanges) {
			<section *requiredCredential="editDnsCredential">
				<button #dnsAdminButton small (click)="openDnsAdmin()"><icon type="external-link" /> {{ 'dns-records.go-to-admin' | translate }}</button>
			</section>
		}
		@if (dnsResponseStatus === dnsResponseStatusEnum.NotFound) {
			<section>
				<button (click)="addDnsForDomain()" [disabled]="domain.metaData !== undefined" [working]="domain.metaData !== undefined"><icon type="plus" /> {{ 'company.domains.add-dns' | translate }}</button>
			</section>
		}
	}
</panel>
@if (communicationLog.length > 0) {
	<panel width="500">
		<h1>{{ 'order.communication-log' | translate }}</h1>
		<scrollable>
			<communication-log [communicationLog]="communicationLog" />
		</scrollable>
	</panel>
}
